export default __webpack_public_path__ + "a6b7c37878dbaccc83de14b494a27597.svg";